import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import Routes from './services/Routes';

export default class App extends React.PureComponent {
  componentDidMount() {
    const cover = document.getElementById('cover');
    cover.classList.add('cover-hidden');
  }

  render() {
    return (
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    );
  }
}
